exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "svg[data-v-462af483]{max-width:100%}", ""]);

